module.exports = __webpack_public_path__ + "static/media/sistemaPegar11.87ac54be.jpg";